// extracted by mini-css-extract-plugin
export var quantityInput = "_mk-0";